import { useState, useEffect } from 'react';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Loader from '../shared/loader';
import Pagination from '../shared/pagination';
import StringHelpers from '../../utilities/stringHelpers';
import arrayUtilities from '../../utilities/arrayUtilities';
import { ErrorModal } from '../../utilities/errorModal';
import { SuccessModal } from '../shared/successModal';
import { toDateString } from '../../utilities/dateUtilities';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterPill, renderTagFilterItemLabel } from '../shared/appliedFilterPill';
import appliedFiltersUtilities from '../../utilities/appliedFiltersUtilities';
import { ClientBreachesFiltersModal } from './filters-modals/clientBreachesFiltersModal';

export const ClientBreaches = ({ organisationId, token, user, tags }) => {
    const [breaches, setBreaches] = useState(null)
    const [sites, setSites] = useState(null);

    const [voidModal, setVoidModal] = useState(null);
    const [reasons, setReasons] = useState(null);
    const [voidReasons, setVoidReasons] = useState(null);
    const [cancelReason, setCancelReason] = useState(null);
    const [voidReason, setVoidReason] = useState(null);
    const [canCancel, setCanCancel] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);

    const [siteId, setSiteId] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);

    const [type, setType] = useState(null);
    const [status, setStatus] = useState(null);
    const [search, setSearch] = useState("");
    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const [loading, setLoading] = useState(false);

    const isVoidAction = voidModal !== null && voidModal.breachStatus === 0;

    const getBreaches = (searchQuery, siteIdValue, typeValue, statusValue, from, to, page, tagIds) => {
        setLoading(true);
        Api.getBreaches(
            (data) => {
                setBreaches(data);
                setLoading(false);
            },
            (error) => {
                console.log(error)
                setLoading(false)
            },
            searchQuery, !StringHelpers.isNullOrEmpty(siteIdValue) ? [siteIdValue] : null, null, null, from, to, typeValue, statusValue === null ? null : [statusValue], null, page, 0, null, null, null,
            null, null,
            tagIds,
            organisationId,
            token, null
        )
    }

    const getReasons = function () {
        Api.getCancellationReasons(
            (data) => setReasons(data),
            (error) => console.log(error),
            organisationId,
            token
        )
    };

    const getVoidReasons = function () {
        Api.getVoidReasons(
            (data) => setVoidReasons(data),
            (error) => console.log(error),
            organisationId,
            token
        )
    };

    const voidTicket = function () {
        Api.voidTicket(
            data => {
                if (data.isError) {
                    setLoading(false)
                    setError(data.errorMessage)
                    setVoidReason(null)
                } else {
                    getBreaches(search, siteId, type, status, filterStart, filterEnd, pageNumber, selectedTags);
                    setLoading(false)
                    setSuccess("Ticket voided successfully")
                    setVoidReason(null)
                }
            },
            (error) => {
                setLoading(false)
                setVoidModal(null)
                setError(error.errorMessage)
                setVoidReason(null)
            },
            voidModal.id,
            voidReason !== null ? voidReason.id : null,
            null,
            organisationId,
            token
        )
    };

    const cancelTicket = function () {
        if (canCancel) {
            Api.cancelTicket(
                data => {
                    if (data.isError) {
                        setLoading(false)
                        setError(data.errorMessage)
                        setCancelReason(null)
                    } else {
                        getBreaches(search, siteId, type, status, filterStart, filterEnd, pageNumber, selectedTags);
                        setLoading(false)
                        setSuccess("Ticket cancelled successfully")
                        setCancelReason(null)
                    }
                },
                (error) => {
                    setLoading(false)
                    setVoidModal(null)
                    setError(error.errorMessage)
                    setCancelReason(null)
                },
                cancelReason.id,
                organisationId,
                voidModal.id,
                token
            )
        }
    };

    const getSites = () => {
        Api.getSites(
            (data) => {
                setSites(data);
                const initialSiteId = (!arrayUtilities.isNullOrEmpty(data) && data.length === 1) ? data[0].id : null;
                if (initialSiteId !== null) {
                    setSiteId(initialSiteId);
                }
                getBreaches(search, initialSiteId, type, status, filterStart, filterEnd, 0, selectedTags);
            },
            (error) => console.log(error),
            organisationId, token
        )
    };

    useEffect(() => {
        getSites()
        getReasons()
        getVoidReasons()
    }, [])

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                getBreaches(search, siteId, type, status, null, null, 0, selectedTags)
                break
            case "Site":
                setSiteId(null)
                getBreaches(search, null, type, status, filterStart, filterEnd, 0, selectedTags)
                break
            case "Type":
                setType(null)
                getBreaches(search, siteId, null, status, filterStart, filterEnd, 0, selectedTags)
                break
            case "Status":
                setStatus(null)
                getBreaches(search, siteId, type, null, filterStart, filterEnd, 0, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                getBreaches(search, siteId, type, status, filterStart, filterEnd, 0, [])
                break
            default:
                break
        }
        setPageNumber(0)
    };

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                getBreaches(search, siteId, type, status, filterStart, filterEnd, 0, remainingIds)
                break
            default:
                break
        }
        setPageNumber(0)
    };

    const changePageNumber = (num) => {
        setPageNumber(num);
        getBreaches(search, siteId, type, status, filterStart, filterEnd, num, selectedTags);
        window.scrollTo({ top: 0 });
    }

    useEffect(() => {
        if (cancelReason !== null) {
            setCanCancel(true);
        } else {
            setCanCancel(false);
        }
    }, [cancelReason]);

    return (
        <div className="card mb-3 col-12">
            <div className="modal fade" id="cancel-modal" tabIndex="-1" role="dialog" aria-labelledby="Cancel Modal" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteModalLabel">{isVoidAction ? "Select a reason to void this ticket." : "Select a reason to cancel this ticket."}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 ">
                                    <p className="font-weight-semi-bold  mt-1 mb-2">Reason:</p>
                                </div>
                                <div className="col-12 ">
                                    <div className="form-group mb-0">
                                        <div className="dropdown ">
                                            <button className="btn btn-falcon-default dropdown-toggle btn-sm mb-1 edit-dropdown" id="select-type" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{(isVoidAction ? voidReason : cancelReason) !== null ? (isVoidAction ? voidReason : cancelReason).name : <>Select Reason</>}</button>
                                            <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-type" >
                                                <div className="bg-white py-2 rounded-soft">
                                                    {
                                                        isVoidAction
                                                            ? !arrayUtilities.isNullOrEmpty(voidReasons) &&
                                                                voidReasons.map(reason => <button key={reason.id} className="dropdown-item text-base px-3 py-2" onClick={() => setVoidReason(reason)}>{reason.name}</button>)
                                                            : !arrayUtilities.isNullOrEmpty(reasons) &&
                                                                reasons.map(reason => <button key={reason.id} className="dropdown-item text-base px-3 py-2" onClick={() => setCancelReason(reason)}>{reason.name}</button>)
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal" onClick={() => { setCancelReason(null); setVoidReason(null); }}>Cancel</button>
                            <button type="button" className="btn btn-success btn-sm ml-2" disabled={!isVoidAction && !canCancel} data-dismiss="modal" onClick={() => isVoidAction ? voidTicket() : cancelTicket()}>
                                Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-header">
                <div className="row align-items-center justify-content-between">
                    <div className="col-auto d-flex align-items-center">
                        <h5 className="mb-0">Breaches</h5>
                    </div>
                    <div className="col-auto d-flex align-items-center">
                        <SearchBarWithDebounce onSearchQueryChange={ query => {
                            setSearch(query)
                            setPageNumber(0)
                            getBreaches(query, siteId, type, status, filterStart, filterEnd, 0, selectedTags)
                        } } />
                        <div className='ml-2'>
                            <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                        </div>
                    </div>
                </div>
            </div>
            {
                showFilterPills && appliedFilters &&
                <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                    {
                        Object.entries(appliedFilters).map(
                            ([label, value]) => <AppliedFilterPill
                                key={ label }
                                label={ label }
                                value={ value }
                                renderItemLabel={ renderTagFilterItemLabel }
                                onTextClick={ () => setShowFiltersModal(true) }
                                onCloseClick={ handleFilterPillClose }
                                onRemoveItem={ handleFilterPillItemRemove }
                            />
                        )
                    }
                    { appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => {
                        setFilterStart(null)
                        setFilterEnd(null)
                        setSiteId(null)
                        setType(null)
                        setStatus(null)
                        setSelectedTags([])
                        setAppliedFilters(null)
                        setPageNumber(0)
                        getBreaches(search, null, null, null, null, null, 0, [])
                    } }>Clear all filters</button> }
                </div>
            }
            <div className="card-body bg-light border-top details-container p-0">
                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer">
                    <thead className="bg-200 text-900">
                        <tr>
                            <th>VRM</th>
                            <th>Site</th>
                            <th>Contravention</th>
                            <th className="text-center">Breach Date</th>
                            <th>Status</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            loading
                                ? <tr><td colSpan={ 6 }><Loader /></td></tr>
                                : <>
                                    { breaches !== null && !arrayUtilities.isNullOrEmpty(breaches.items) && breaches.items.map(breach =>
                                            <tr key={ breach.id }>
                                                <td><h6 className="mb-0 small-number-plate">{ breach.vrm }</h6></td>
                                                <td>{ breach.siteName }</td>
                                                <td>{ breach.contraventionName }</td>
                                                <td className="text-center">{ breach.timestamp !== null && toDateString(breach.timestamp) }</td>
                                                <td>{ Enums.BreachStatus[breach.breachStatus] }</td>
                                                <td className='text-right'>
                                                    {
                                                        breach.breachStatus === 0
                                                            ? <button
                                                                data-toggle="modal" data-target="#cancel-modal"
                                                                className="btn btn-danger btn-sm col-auto ml-2"
                                                                onClick={ () => setVoidModal(breach) }>
                                                                <i className="fas fa-ban"></i> Void Ticket
                                                            </button>
                                                            : <button
                                                                disabled={ breach.breachStatus === 404 || breach.breachStatus >= 500 }
                                                                data-toggle="modal" data-target="#cancel-modal"
                                                                className="btn btn-danger btn-sm col-auto ml-2"
                                                                onClick={ () => setVoidModal(breach) }>
                                                                <i className="fas fa-times"></i> Cancel Ticket
                                                            </button>
                                                    }
                                                </td>
                                            </tr>
                                        ) }
                                </> }
                    </tbody>
                </table>
            </div>
            <div className="card-footer border-top ">
                <div className="d-flex justify-content-center row ">
                    <div className="col-auto ">
                        <Pagination totalResults={ breaches?.totalCount } currentPage={ pageNumber } changePageNumber={ changePageNumber } />
                    </div>
                </div>
            </div>
            { !StringHelpers.isNullOrEmpty(error) && <ErrorModal message={ error } onHide={ () => setError(null) } /> }
            { !StringHelpers.isNullOrEmpty(success) && <SuccessModal message={ success } onHide={ () => setSuccess(null) } /> }
            {
                showFiltersModal &&
                <ClientBreachesFiltersModal
                    showModal={ showFiltersModal }
                    handleClose={ () => setShowFiltersModal(false) }
                    handleConfirm={ (draftFilters) => {
                        setFilterStart(draftFilters.filterStart)
                        setFilterEnd(draftFilters.filterEnd)
                        setSiteId(draftFilters.siteId)
                        setType(draftFilters.type)
                        setStatus(draftFilters.status)
                        setSelectedTags(draftFilters.selectedTags)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        setPageNumber(0)
                        getBreaches(search, draftFilters.siteId, draftFilters.type, draftFilters.status, draftFilters.filterStart, draftFilters.filterEnd, 0, draftFilters.selectedTags)
                    } }
                    initialFilterStart={ filterStart }
                    initialFilterEnd={ filterEnd }
                    initialSiteId={ siteId }
                    initialType={ type }
                    initialStatus={ status }
                    initialSelectedTags={ selectedTags }
                    initialAppliedFilters={ appliedFilters }
                    sites={ sites ?? [] }
                    tags={ tags ?? [] }
                    key="client-breaches-filters-modal"
                />
            }
        </div>
    )
}
